document.addEventListener('turbolinks:before-render', () => {
  window.disableDownloadLimitModal = false;
});
